import { Roles } from '@app/models/user';

export const isPlanner = role => {
  return (
    role === Roles.Planner ||
    role === Roles.ProductManager ||
    role === Roles.CategoryManger ||
    role === Roles.RegionalManager
  );
};
export const isDesigner = role => role === Roles.Designer;
export const isRegionalBuyer = role => {
  return role === Roles.RegionalBuyer;
};
export const isCountryBuyer = role => role === Roles.CountryBuyer;
export const isAdmin = role => role === Roles.Admin;
export const isManager = role => role === Roles.Manager;
export const isComex = role => role === Roles.Comex;
export const isCountryPlanner = role => role === Roles.CountryPlanner;
export const isRegionalManager = role => role === Roles.RegionalManager;
export const isCountryManager = role => role === Roles.CountryManager;
export const isCountryBoss = role => role === Roles.CountryBoss;
export const isRegionalBoss = role => role === Roles.RegionalBoss;
export const isProductManager = role => role === Roles.ProductManager;
export const isRegionalAnalyst = role => role === Roles.RegionalAnalyst;
export const isPackaging = role => role === Roles.Packaging;
export const isPackagingManager = role => role === Roles.PackagingManager;
export const isComexCountry = role => role === Roles.ComexCountry;
export const isCategoryManager = role => role === Roles.CategoryManger;
export const isSar = role => role === Roles.Sar;
export const isSupervisorQC = role => role === Roles.SupervisorQC;
export const isSuperAdmin = role => role === Roles.SuperAdmin;
export const isMerchant = role => role === Roles.Merchant;
export const isSupplier = role => role === Roles.Supplier;
export const isManagerUdn = role => role === Roles.ManagerUdn;
export const isManagerVisualizer = role => role === Roles.ManagerVisualizer;

export const isCountryUser = role => {
  return (
    isCountryBuyer(role) ||
    isCountryPlanner(role) ||
    isCountryManager(role) ||
    isCountryBoss(role)
  );
};

export const isRegionalUser = role => {
  return (
    isRegionalBuyer(role) ||
    isPlanner(role) ||
    isRegionalManager(role) ||
    isRegionalBoss(role) ||
    isProductManager(role) ||
    isCategoryManager(role)
  );
};

export const isOnlyRegionalUser = role => {
  return (
    isRegionalBuyer(role) ||
    isRegionalManager(role) ||
    isRegionalBoss(role) ||
    isProductManager(role) ||
    isCategoryManager(role)
  );
};
